import { service } from '../../../helpers/http'

export const ActionIndexMenuAccessBlocks = ({ dispatch }, payload) => {

    return service({
        module: 'menuAccessBlock',
        action: 'index',
        payload: payload
    })
}

export const ActionStoreMenuAccessBlock = ({ dispatch }, payload) => {

    return service({
        module: 'menuAccessBlock',
        action: 'store',
        payload: payload
    })

}

export const ActionUpdateMenuAccessBlock = ({ dispatch }, payload) => {

    return service({
        module: 'menuAccessBlock',
        action: 'update',
        payload: payload
    })

}

export const ActionDestroyMenuAccessBlock = ({ dispatch }, payload) => {

    return service({
        module: 'menuAccessBlock',
        action: 'destroy',
        payload: payload
    })

}

const POLL_INTERVAL_MS = 20000

/**
 * Checagem leve (guard de navegação): busca os menus atualmente bloqueados
 * para o usuário logado. O backend já faz o short-circuit (não faz o join
 * com perfis se não houver nenhum bloqueio vigente), então essa chamada é
 * barata mesmo quando nenhuma configuração está ativa.
 */
export const ActionCheckBlockedRoutes = async ({ commit, rootGetters }) => {
    if (!rootGetters['auth/hasToken']) {
        return []
    }

    commit('SET_LOADING', true)

    try {
        const res = await service({
            module: 'menuAccessBlock',
            action: 'checkBlockedRoutes',
        })
        const routes = res.data?.blocked_routes || res.data?.data?.blocked_routes || []
        commit('SET_BLOCKED_ROUTES', routes)
        return routes
    } catch (error) {
        return []
    } finally {
        commit('SET_LOADING', false)
    }
}

export const ActionStartBlockPolling = ({ state, dispatch, commit }) => {
    if (state.poll_handle) return

    const handle = setInterval(() => {
        if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return
        dispatch('ActionCheckBlockedRoutes')
    }, POLL_INTERVAL_MS)

    commit('SET_POLL_HANDLE', handle)
}

export const ActionStopBlockPolling = ({ state, commit }) => {
    if (state.poll_handle) {
        clearInterval(state.poll_handle)
        commit('SET_POLL_HANDLE', null)
    }
}
